import { inject } from '@vercel/analytics';

// Vanilla (non-React) entry — see https://vercel.com/docs/analytics/quickstart
inject();
